import type { ParkingStatus } from '@repo/domain';
import { ArrowsRotateIcon, ExclamationCircleIcon, type MyIcon } from '@repo/icons';
import type { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import StatusInfo from '@features/ownedParkingManage/components/StatusInfo';

type ParkingStatusLimited = Exclude<ParkingStatus, 'draft' | 'active'>;

interface Props {
  status: ParkingStatusLimited;
  testId: TestId;
}

const DETAILS: Record<
  ParkingStatusLimited,
  {
    className: string;
    titleTranslationKey: string;
    infoTranslationKey?: string;
    icon: MyIcon;
  }
> = {
  pendingVerification: {
    className: 'bg-brand-softer border-brand-soft border text-fg-brand-strong',
    titleTranslationKey: 'owned_parking_manage:parking_statuses.pending_verification.title',
    infoTranslationKey: 'owned_parking_manage:parking_statuses.pending_verification.info',
    icon: ArrowsRotateIcon,
  },
  rejectedVerification: {
    className: 'bg-warning-strong text-white',
    titleTranslationKey: 'owned_parking_manage:parking_statuses.rejected_verification.title',
    infoTranslationKey: 'owned_parking_manage:parking_statuses.rejected_verification.info',
    icon: ExclamationCircleIcon,
  },
  paused: {
    className: 'bg-warning-strong text-white',
    titleTranslationKey: 'owned_parking_manage:parking_statuses.paused.title',
    infoTranslationKey: 'owned_parking_manage:parking_statuses.paused.info',
    icon: ExclamationCircleIcon,
  },
  suspended: {
    className: 'bg-warning-strong text-white',
    titleTranslationKey: 'owned_parking_manage:parking_statuses.suspended.title',
    infoTranslationKey: 'owned_parking_manage:parking_statuses.suspended.info',
    icon: ExclamationCircleIcon,
  },
};

export default function ManageParkingStatusInfo({ status, testId }: Props) {
  const details = DETAILS[status];

  return (
    <StatusInfo
      className={details.className}
      title={tr(details.titleTranslationKey)}
      info={details.infoTranslationKey && tr(details.infoTranslationKey)}
      icon={details.icon}
      testId={testId.append(status)}
    />
  );
}
